export default {
  setMap(state, payload) {
    state.map = payload;
  },
};
